import PropTypes from "prop-types";
import ContactOurExperts from "app/pages/.shared/ContactOurExperts";
import "./dont-leave.scss";

const DontLeave = ({ children, message, showPhonePicto = false, displayPhoneNumber = true }) => {
	return (
		<div className="dont-leave">
			<div className="dont-leave__contact">
				<ContactOurExperts
					message={message}
					showPhonePicto={showPhonePicto}
					displayPhoneNumber={displayPhoneNumber}
				/>
			</div>

			{children ? <div className="dont-leave__button">{children}</div> : false}
		</div>
	);
};

DontLeave.propTypes = {
	showPhonePicto: PropTypes.bool,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	displayPhoneNumber: PropTypes.bool,
};

export default DontLeave;
